import { AdornisRouter } from '@adornis/base/client/a-router';

AdornisRouter.init(['/:page', '/blog/post/:postID', '/create_profile/:step']);
